export default {"src":"/_next/static/media/icon_account_issues.72d94af5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};